import React, { useState } from 'react';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function NotificationsPage() {
  const [form, setForm] = useState({ title:"", message:"", targetRole:"all" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState([]);

  const set = (k,v) => setForm(p=>({...p,[k]:v}));

  const send = async () => {
    if (!form.message.trim()) return toast.error("Message is required");
    setSending(true);
    try {
      await api.post("/admin/broadcast", form);
      toast.success("Broadcast sent!");
      setSent(p => [{ ...form, sentAt:new Date(), id:Date.now() }, ...p]);
      setForm({ title:"", message:"", targetRole:"all" });
    } catch { toast.error("Failed to send"); }
    finally { setSending(false); }
  };

  const TEMPLATES = [
    { label:"Market open", message:" Zeva2 market is open today! New crops available." },
    { label:"New feature", message:"🎉 We just launched a new feature! Update your app to try it." },
    { label:"Reminder",    message:"📦 You have pending crop requests. Login to check them." },
    { label:"Maintenance", message:"⚠️ Platform maintenance scheduled. Service may be unavailable briefly." },
  ];

  return (
    <AdminLayout title="Broadcast Notifications">
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:20 }}>
        <div>
          <div className="card" style={{ marginBottom:16 }}>
            <div className="card__header"><div className="card__title">📢 Send Broadcast</div></div>
            <div className="card__body">
              <div className="form-group">
                <label className="label">Target Audience</label>
                <select className="input" value={form.targetRole} onChange={e=>set("targetRole",e.target.value)}>
                  <option value="all">All Users</option>
                  <option value="seller">Farmers Only</option>
                  <option value="buyer">Buyers Only</option>
                  <option value="agent">Agents Only</option>
                </select>
              </div>
              <div className="form-group">
                <label className="label">Title (optional)</label>
                <input className="input" placeholder="Notification title" value={form.title} onChange={e=>set("title",e.target.value)} />
              </div>
              <div className="form-group">
                <label className="label">Message *</label>
                <textarea className="input" rows={4} placeholder="Your broadcast message..." value={form.message} onChange={e=>set("message",e.target.value)} />
              </div>
              <button className="btn btn--primary btn--full" onClick={send} disabled={sending}>
                {sending ? <><span className="spinner spinner--sm spinner--white" /> Sending...</> : "📤 Send Broadcast"}
              </button>
            </div>
          </div>
        </div>

        <div>
          <div className="card" style={{ marginBottom:16 }}>
            <div className="card__header"><div className="card__title">⚡ Quick Templates</div></div>
            <div className="card__body">
              <div style={{ display:"flex", flexDirection:"column", gap:8 }}>
                {TEMPLATES.map(t => (
                  <button key={t.label} className="btn btn--outline btn--sm" style={{ textAlign:"left", justifyContent:"flex-start" }}
                    onClick={() => set("message", t.message)}>
                    {t.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="card">
            <div className="card__header"><div className="card__title">📜 Recent Sent ({sent.length})</div></div>
            <div className="card__body--sm">
              {sent.length === 0 ? (
                <div style={{ color:"#6C757D", fontSize:13, textAlign:"center", padding:16 }}>No broadcasts sent yet</div>
              ) : sent.map(s => (
                <div key={s.id} style={{ padding:"10px 0", borderBottom:"1px solid #f1f3f5" }}>
                  <div style={{ fontSize:12, fontWeight:600 }}>{s.title || "Notification"} <span style={{ color:"#6C757D", fontWeight:400 }}>→ {s.targetRole}</span></div>
                  <div style={{ fontSize:12, color:"#6C757D", marginTop:2 }}>{s.message.slice(0,60)}...</div>
                  <div style={{ fontSize:11, color:"#ADB5BD", marginTop:2 }}>{s.sentAt.toLocaleTimeString("en-IN")}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
